import React from 'react'
import styled from 'styled-components'
import { MdWarning, MdSettings } from 'react-icons/md'
import { MobergFontFamily } from '../MobergFont/MobergFont'

const DisplayWarningToast = ({ onConfigure, isVisible = false, showCloseButton = true, isSafari = false }) => {
    if (!isVisible) return null

    return (
        <ToastContainer>
            <WarningBar />
            <ToastContent>
                <WarningIcon>
                    <MdWarning size={20} />
                </WarningIcon>
                <ToastText>
                    <WarningTitle>Warning</WarningTitle>
                    <WarningMessage>
                        {isSafari ? 'Safari is not supported' : 'Display area is too small'}
                    </WarningMessage>
                </ToastText>
                <ActionButtons>
                    <ConfigureButton onClick={onConfigure}>
                        <MdSettings size={16} />
                        Configure
                    </ConfigureButton>

                </ActionButtons>
            </ToastContent>
        </ToastContainer>
    )
}

const ToastContainer = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    background: var(--color-surface-menu);
    border-radius: 4px;
    box-shadow: var(--modal-box-shadow);
    border: 1px solid var(--color-border-default);
    max-width: 400px;
    z-index: 100;
    animation: slideIn 0.3s ease-out;
    
    @keyframes slideIn {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
`

const WarningBar = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: #f59e0b;
    border-radius: 4px 0 0 4px;
`

const ToastContent = styled.div`
    display: flex;
    align-items: center;
    padding: 16px;
    gap: 12px;
`

const WarningIcon = styled.div`
    color: #f59e0b;
    display: flex;
    align-items: center;
    flex-shrink: 0;
`

const ToastText = styled.div`
    flex: 1;
    min-width: 0;
`

const WarningTitle = styled.div`
    font-family: ${MobergFontFamily.HEADER};
    font-size: 14px;
    font-weight: 600;
    color: var(--color-text-primary);
    margin-bottom: 4px;
`

const WarningMessage = styled.div`
    font-family: ${MobergFontFamily.REGULAR};
    font-size: 13px;
    color: var(--color-text-primary);
    line-height: 1.4;
`

const ActionButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`

const ConfigureButton = styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    background: var(--color-accent-interactive);
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    font-family: ${MobergFontFamily.HEADER};
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
        filter: brightness(0.85);
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
`

export default DisplayWarningToast 